import { render, staticRenderFns } from "./UserAvatarBus.vue?vue&type=template&id=7e7582ca"
import script from "./UserAvatarBus.vue?vue&type=script&lang=js"
export * from "./UserAvatarBus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports